module.exports = __webpack_public_path__ + "static/media/edit-icon-solid.5d72d2f0.svg";